import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLine, Eyebrow, EASE } from "@/components/Reveal";

const STATS = [
  { value: "8+", label: "Active Investments" },
  { value: "3", label: "Successful Exits" },
  { value: "10+", label: "Jahre Erfahrung" },
];

const ClipImage = ({ src, alt, className, imgClass, delay = 0, y }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }}>
    <motion.div
      className="h-full w-full overflow-hidden"
      variants={{ hidden: { clipPath: "inset(100% 0% 0% 0%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
      transition={{ duration: 1.3, ease: EASE, delay }}
    >
      <motion.img src={src} alt={alt} style={y ? { y } : undefined}
        variants={{ hidden: { scale: 1.25 }, show: { scale: 1 } }}
        transition={{ duration: 1.8, ease: EASE, delay }}
        className={`h-full w-full object-cover ${imgClass}`} />
    </motion.div>
  </motion.div>
);

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const smallY = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="about" className="py-24 md:py-36 bg-secondary/40" data-testid="about-section">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <Reveal><Eyebrow className="mb-8">Über MKSL</Eyebrow></Reveal>
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-start">
          <div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight mb-8">
              <MaskLine>Mehr als Beratung.</MaskLine>
              <MaskLine delay={0.12} className="text-muted-foreground">Echte Partnerschaft.</MaskLine>
            </h2>
            <Reveal delay={0.15} className="space-y-6 text-base md:text-lg text-muted-foreground leading-relaxed">
              <p>
                MKSL Consulting ist die persönliche Holding von <span className="text-foreground font-medium">Maximilian Schneider-Ludorff</span>. Ich begleite Start-ups als strategischer Partner und helfe beim Aufbau von digitaler Infrastruktur, Produktentwicklung, Go-to-Market, Teamprozessen und Investor Relations.
              </p>
              <p>
                Meine Zusammenarbeit basiert auf direkten <span className="text-foreground font-medium">Beteiligungen</span> – und Consulting. Ich investiere Zeit, Expertise und Netzwerk auf unternehmerischer Augenhöhe für langfristigen gemeinsamen Erfolg.
              </p>
            </Reveal>
            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-border pt-10">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={0.1 * i} data-testid={`about-stat-${i}`}>
                  <div className="font-display text-3xl md:text-5xl font-medium">{s.value}</div>
                  <div className="text-xs md:text-sm text-muted-foreground mt-2">{s.label}</div>
                </Reveal>
              ))}
            </div>
          </div>
          <div ref={ref} className="relative pb-10 pl-6 md:pl-8">
            <ClipImage src="/assets/main-wide-U7IlMA-g.jpg" alt="Maximilian Schneider-Ludorff speaking at a conference"
              className="aspect-[16/10] rounded-lg shadow-xl overflow-hidden" imgClass="object-center" />
            <motion.div style={{ y: smallY }} className="absolute -bottom-6 left-0 w-32 md:w-44 z-10">
              <ClipImage src="/assets/secondary-BX_6EdMT.jpg" alt="Maximilian Schneider-Ludorff" delay={0.35}
                className="aspect-[3/4] rounded-lg shadow-lg overflow-hidden border-4 border-background" imgClass="object-top" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
